import { makeQuery } from "src/queries/makeQuery";
import type {
  ClusterRelativeTasksResponse,
  ClusterRunRelativeTasksRunResponse,
  ClusterRunResponse,
  Compute,
  ComputeRunDetails,
} from "./compute.types";

/**
 * List of compute (clusters)
 */
export const useQueryComputes = makeQuery<Compute[]>("/api/computes", {
  queryParams: ["timeWindow", "appOwners", "appTags", "env_name", "is_debug_mode"],
});

/**
 * Compute run details
 */
export const useQueryCompute = makeQuery<ComputeRunDetails>(
  (p) => `/api/computes/${p.task_id}`
);

/**
 * List of specific cluster runs
 */
export const useQueryClusterRuns = makeQuery<ClusterRunResponse[]>(
  (p) => `/api/envs/${p.env_name}/computes/${p.app_name}/runs`,
  {
    queryParams: [
      "timeWindow",
      "appOwners",
      "appTags",
      { task_name: (p) => p.cluster_name },
    ],
  }
);

/**
 * Cluster relative tasks
 */
export const useQueryClusterRelativeTasks = makeQuery<
  ClusterRelativeTasksResponse[]
>((p) => `/api/envs/${p.env_name}/computes/${p.app_name}/tasks`, {
  queryParams: [
    "timeWindow",
    "appOwners",
    "appTags",
    { task_name: (p) => p.cluster_name },
  ],
  enabled: (p) => !!p.cluster_name,
});

/**
 * Cluster run relative tasks runs
 */
export const useQueryClusterRunRelativeTasksRuns = makeQuery<
  ClusterRunRelativeTasksRunResponse[]
>((p) => `/api/computes/${p.task_id}/tasks`, {
  queryParams: ["timeWindow", "appOwners", "appTags", "env_name"],
});
